module.exports = __webpack_public_path__ + "img/5223e48.jpg";